"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FENCE_TITLE_DOC_LABEL = exports.TITLE_DOCUMENT_TYPES = void 0;
exports.isTitleDocumentType = isTitleDocumentType;
// The document types that evidence title to the goods — what a financing partner
// (Rivonia, via Fence) holds as security. A title document is an ocean Bill of
// Lading, a CMR (road transport), a multimodal Bill of Lading, or a weighbridge
// ticket. This is the SINGLE source of truth: the eligibility `title_document_present`
// fact and the data-tape/Fence title-document emission both read this set, so the
// "is this a title document?" question is answered in exactly one place.
//
// Typed `satisfies readonly BLOrderDocumentType[]` so every title-document type is
// provably an uploadable document type — a value here that is not in
// BL_ORDER_DOCUMENT_TYPES fails the build.
exports.TITLE_DOCUMENT_TYPES = [
    'bill_of_lading',
    'cmr',
    'multimodal_bill_of_lading',
    'weighbridge_ticket',
];
function isTitleDocumentType(value) {
    return exports.TITLE_DOCUMENT_TYPES.includes(value);
}
exports.FENCE_TITLE_DOC_LABEL = {
    bill_of_lading: 'B/L',
    cmr: 'CMR',
    multimodal_bill_of_lading: 'Multimodal B/L',
    weighbridge_ticket: 'Weighbridge Ticket',
};
//# sourceMappingURL=title-document-types.js.map